import { RG_TYPE as w, deepAddParent as V, RgCreate as F, deepFlatChildrenOfType as $, roundDecimals as k } from "@project-rouge/rg-core";
import { Vector3 as O, MathUtils as Y } from "three";
import { deepApplyTransform as L } from "../../geometry-utils/core/index4.js";
import { getLineDirection as C } from "../../geometry-utils/core/index8.js";
import { rotateAroundY as B } from "../../geometry-utils/core/index23.js";
import { getEuler as G } from "../../geometry-utils/three/index7.js";
import { getPivot as E } from "../../geometry-utils/three/index12.js";
import { distanceToLine as H } from "../../geometry-utils/three/index18.js";
import { V3toVector3 as S } from "../../geometry-utils/index9.js";
import { SignedAngle as D } from "../../utils/index32.js";
import { createRgObjectsOnLines as K } from "../boundary/index.js";
import { getLevelOuterBoundary as U } from "../boundary/index7.js";
const W = new O(), j = new O();
function lo({ building: o, facadeModId: s = void 0, openingDistanceThreshold: l = 0.135, rvDataList: d = [] }) {
  if (o.data.levels.length === 0)
    throw new Error("Fa\xE7ade could not be created, Building has no levels!");
  if (o.children.some((t) => t.type === w.Facade))
    throw new Error("Building already contains fa\xE7ade elements! Fa\xE7ade generation has been cancelled.");
  const c = s ? d.find((t) => t.modulousId === s) : void 0, p = c && c.totalThickness ? c.totalThickness : 0.3, x = new O(1, 0, 0).applyEuler(G(o)).normalize(), n = o.data.levels.sort((t, e) => t.floorWorldBottom - e.floorWorldBottom), u = /* @__PURE__ */ new Map();
  for (const t of n)
    u.has(t.levelIndex) || u.set(t.levelIndex, []), u.get(t.levelIndex).push(t);
  const P = o.data.levels.filter(({ isPodium: t }) => t);
  let m = n[0];
  if (P) {
    const t = P.slice().sort((A, y) => A.levelIndex - y.levelIndex), e = t[0], a = t[t.length - 1], i = n.indexOf(a) + 1;
    i < n.length ? m = n[i] : m = n[n.indexOf(e) - 1];
  }
  V(o);
  const f = [], h = {};
  for (const t of n)
    q({ level: t, building: o, levelsByIndex: u, templates: h, rvDataList: d, facades: f, podiumProjectionLevel: m, facadeWidth: p, facadeData: c, threshold: l, buildingAxis: x });
  o.children.push(...f);
  const I = o.data.anatomy;
  return o.data.anatomy = I, f;
}
function _(o) {
  return `${o.length}|${o.map((s) => `${s.type}|${s.size[0]}|${s.size[2]}`).join("|")}`;
}
function q({ level: o, building: s, levelsByIndex: l, templates: d, rvDataList: c, facades: p, podiumProjectionLevel: z, facadeWidth: x, facadeData: n, threshold: u, buildingAxis: P }) {
  const m = s.children.filter((r) => r.type !== w.Facade && r.data.levelId === o.uuid);
  let f = 0;
  o.isRoof && (f = o.floorWorldBottom - l.get(o.levelIndex)[0].floorWorldBottom);
  let h = f;
  if (!o.isRoof && l.get(o.levelIndex + 1))
    h += l.get(o.levelIndex + 1)[0].floorWorldBottom - o.floorWorldBottom;
  else {
    const r = m.filter((g) => g.type === w.Parapet), v = Math.max(...r.map((g) => g.pos[1])), T = Math.max(...r.map((g) => g.size[1])), M = v - o.floorWorldBottom + T;
    h += M;
  }
  const I = s.pos[1] + o.floorWorldBottom - f, t = _(m);
  if (d[t]) {
    for (const r of d[t]) {
      const v = F({ ...r }, c || []);
      v.size[1] = h, v.pos[1] = I, v.data.level = o.levelIndex, v.data.levelId = o.uuid, p.push(v);
    }
    return;
  }
  const a = m.flatMap((r) => $(r, w.Wall)).flatMap((r) => r.children), i = [0.5, 0, 0.5], A = a.map((r) => L(E(i, r), r)).map(S), y = U(s, o.isPodium ? z : o, x), R = K({
    lines: y,
    thickness: x,
    height: h,
    partial: {
      type: w.Facade,
      modulousId: n ? n.modulousId : "",
      name: "facade",
      data: { level: o.levelIndex, levelId: o.uuid },
      children: []
    },
    rvDataList: c
  });
  d[t] = [];
  for (let r = 0; r < y.length; r++)
    J({
      facade: R[r],
      line: y[r],
      templateList: d[t],
      openings: a,
      openingsPivots: A,
      threshold: u,
      building: s,
      pivot: i,
      rvDataList: c,
      buildingAxis: P,
      facades: p,
      y: I
    });
}
function J({ facade: o, line: s, openings: l, openingsPivots: d, threshold: c, building: p, pivot: z, rvDataList: x, buildingAxis: n, facades: u, templateList: P, y: m }) {
  if (k(o.size[0]) <= 0)
    return;
  const f = C(s);
  W.fromArray(s[0]), j.fromArray(s[1]);
  const h = [];
  for (let e = 0; e < l.length; e++) {
    const a = d[e], { distance: i } = H(a, [W, j], 1);
    i < c && h.push({
      obj: l[e],
      pivot: a,
      line: {
        start: L(E([0, 0, 0.5], l[e]), l[e]),
        end: L(E([1, 0, 0.5], l[e]), l[e])
      }
    });
  }
  o.pos[1] = m;
  for (const e of h) {
    let a = B([e.pivot.toArray()], o.pos, o.rot[1])[0];
    a = B([a], o.pos, p.rot[1])[0];
    const i = F({
      name: "opening",
      children: [],
      type: w.Opening,
      pos: a.map((A, y) => A - o.pos[y]),
      size: [e.obj.size[0], e.obj.size[1], o.size[2]],
      anchor: z,
      rot: [0, 0, 0],
      alpha: 0.5
    }, x);
    i.pos[2] = -i.size[2] * i.anchor[2], o.children.push(i);
  }
  const I = B([o.pos], p.pos, p.rot[1])[0];
  o.pos = I.map((e, a) => e - p.pos[a]), o.rot = [0, -D(f, n) * Y.RAD2DEG, 0], u.push(o);
  const t = F({ ...o }, x || []);
  t.pos[1] = 0, t.data.level = -1, P.push(t);
}
export {
  lo as createFacadeFromBoundary
};
//# sourceMappingURL=index.js.map
